// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as GAEvents from "../../../library/ga/GAEvents.bs.js";
import * as SupportHeader from "./common/SupportHeader.bs.js";
import * as SupportErrorBody from "./Error/SupportErrorBody.bs.js";
import * as SupportAssetsManager from "../assets/SupportAssetsManager.bs.js";

SupportAssetsManager.importCss(undefined);

function SupportErrorView(Props) {
  var language = Props.language;
  console.log(language);
  GAEvents.publishEvent("Porter Chat Support", "", undefined, "Unable to load chat support", undefined, undefined);
  return React.createElement(React.Fragment, undefined, React.createElement(SupportHeader.make, {}), React.createElement("div", {
                  className: "support-error-container"
                }, React.createElement(SupportErrorBody.make, {})));
}

var make = SupportErrorView;

export {
  make ,
  
}
/*  Not a pure module */
